// L'état que toute l'interface partage : qui je suis, et le référentiel de la grille.
export interface Session {
  id: string; email: string; trigramme: string; prenom: string; nom: string;
  role: 'administrateur' | 'contributeur' | 'lecture';
}

export interface Referentiel {
  roles: { cle: string; libelle: string; famille: string; regie: [number, number] }[];
  familles: Record<string, string>;
}

export const estAdmin = (s: Session) => s.role === 'administrateur';
export const peutEcrire = (s: Session) => s.role !== 'lecture';
